<template>
  <section v-if="pax && pax['covid19_portal'] && pax['covid19_portal']['1']">
    <Title :title-name="titleOfPage" :title-link="pageTitle.titleLink" />
    <div class="my-documents container" :class="{ opacity: isOpen }">
      <div>
        <ItemOfVouchers icon="personal-documents" color="#0094d5" :label="lang['personal_document'].SFS_LANG_ROW_1" border />
      </div>
      <div class="ws-textbox my-4">
        <div class="mb-2">{{ lang['personal_document'].SFS_LANG_ROW_2 }}</div>
        <ul class="section-mandatory-document mb-0">
          <li
            v-for="(document, index) in documents"
            :key="index"
            class="mandatory-documents"
            :class="{ 'mb-3': index < documents.length - 1 }"
          >
            <div class="row">
              <div class="col-10 d-flex">
                <span class="air-doc-title text-decoration-underline" @click="handleOpenFile(document.air_doc_path, $event)">
                  {{ document.air_doc_title }}
                </span>
              </div>
              <div class="col-2 text-right d-flex justify-content-end align-items-center">
                <label v-if="document.checked || document.pass_doc_path" class="ws-checkbox-container">
                  <input
                    :id="'checkbox' + index"
                    :checked="document.checked == 1 ? true : false"
                    type="checkbox"
                    name="documentCheck"
                    class="custom-control-input"
                    @change="handleChecked(index, $event)"
                  />
                  <span class="ws-checkbox-container__checkmark"></span>
                </label>
              </div>
            </div>
            <div
              class="row background-grey"
              :class="document.pass_doc_path ? 'my-documents-item' : ''"
              @click="handleOpenFile(document.pass_doc_path, $event)"
            >
              <div class="col-8 d-flex align-items-center">
                <i class="far fa-lg fa-file-alt"></i>
                <span class="ml-2 air-doc-title">
                  {{ document.pass_doc_path ? document.air_doc_title + '.pdf' : '' }}
                </span>
              </div>
              <div v-if="document.pass_doc_path" class="col-4 text-right padding-right-5px">
                &nbsp;<i class="fas fa-md fa-trash-alt my-documents-item-icon mr-1" @click="handleDelete(index, $event)"></i>
              </div>
              <div v-else :class="['col-4',direction == 'rtl' ? 'text-left' : 'text-right','padding-right-5px']">
                <i
                  class="fas fa-md fa-plus-circle my-documents-item-icon my-documents-item-icon--add mr-1"
                  @click="handleClickFileUpload(index, $event)"
                ></i>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <input
        id="file"
        ref="fileInput"
        type="file"
        accept="image/*;application/pdf;capture=camera"
        class="d-none"
        @change="handleFileUpload($event)"
      />
    </div>
  </section>
</template>
<script>
import '@/assets/scss/modules/MyDocument.scss'
import { mapGetters } from 'vuex'
import Title from '@/components/Title/index'
import ItemOfVouchers from '@/components/ItemOfVouchers/index'

export default {
  name: 'MyDocument',
  components: { Title, ItemOfVouchers },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pageTitle: {},
      isOpen: false,
      file: '',
      documentUrl: '',
      documents: [],
      idx: 0,
      checkedFiles: []
    }
  },
  computed: {
    ...mapGetters({
      Cmtpax: 'MyDocument/Cmtpax'
    }),
    titleOfPage() {
      const { lang } = this
      return lang && lang.hotel_mobile_new && this.lang.hotel_mobile_new.SFS_LANG_ROW_28
        ? lang.hotel_mobile_new.SFS_LANG_ROW_28
        : 'Home'
    }
  },
  watch: {
    title: function (el) {
      if (el) {
        if (this.$route.query.isHome) {
          if (el.MyDocumentsHome) {
            this.pageTitle = el.MyDocumentsHome
          }
        } else {
          if (el.MyDocuments) {
            this.pageTitle = el.MyDocuments
          }
        }
      }
    }
  },
  created() {
    if (this.title) {
      if (this.$route.query.isHome) {
        if (this.title.MyDocumentsHome) {
          this.pageTitle = this.title.MyDocumentsHome
        }
      } else {
        if (this.title.MyDocuments) {
          this.pageTitle = this.title.MyDocuments
        }
      }
    }
    this.$store.dispatch('MessagesList/getCmtpax')
    this.getDocument()
  },
  methods: {
    replaceMessage(v) {
      return v.substr(0, 20)
    },
    handleClickFileUpload(idx) {
      this.$refs.fileInput.click()
      this.idx = idx
    },
    handleFileUpload: function (event) {
      if (event) {
        event.stopPropagation()
      }

      this.file = this.$refs.fileInput.files[0]
      this.submitFile(event)
    },
    submitFile(event) {
      if (!this.file) {
        return false
      }

      let self = this
      var idx = self.idx
      let formData = new FormData()
      formData.set('secret', this.secret)
      formData.set('airline_document_id', this.documents[idx].airline_document_id)
      formData.set('document_title', this.documents[idx].air_doc_title)
      formData.append('file', this.file)

      // Upload file
      this.$store
        .dispatch('MyDocument/uploadFile', {
          formData
        })
        .then((response) => {
          if (response.success) {
            this.$set(this.documents[idx], 'pass_doc_path', response.data.url)
            this.handleChecked(idx, { target: { checked: true } })
            event.target.value = null
          } else {
            let uploadFail = self.pax['covid19_portal'][1].UPLOAD_FILE_FAIL
              ? self.pax['covid19_portal'][1].UPLOAD_FILE_FAIL
              : 'Upload file fail'

            let buttonOk = self.pax['covid19_portal'][1].CONFIRM_TEXT ? self.pax['covid19_portal'][1].CONFIRM_TEXT : 'OK'

            this.$swal({ title: uploadFail, confirmButtonText: buttonOk })
            event.target.value = null
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    // Process checked
    handleChecked(index, e) {
      const { checked } = e.target
      this.$set(this.documents[index], 'checked', checked ? 1 : 0)
      this.updateChecked(index)
    },
    updateChecked(index) {
      var air_doc_id = this.documents[index].airline_document_id
      var title = this.documents[index].air_doc_title
      // Send data
      this.$store
        .dispatch('MyDocument/updateChecked', {
          data_form: {
            secrect: this.secret,
            checked: this.documents[index].checked,
            airline_document_id: air_doc_id,
            document_title: title
          }
        })
        .then((response) => {
          if (response.success) {
            this.$set(this.documents[index], 'passenger_doc_id', response.data.id)
            this.$set(this.documents[index], 'passenger_id', response.data.passenger_id)
            this.$set(this.documents[index], 'airline_document_id', response.data.airline_document_id)
            this.$set(this.documents[index], 'checked', response.data.checked)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    getDocument() {
      this.$store
        .dispatch('MyDocument/getDocuments', {
          data: {
            secrect: this.secret
          }
        })
        .then((response) => {
          if (response.success) {
            this.documents = response.data
          }
        })
    },
    handleDelete: function (index, event) {
      if (event) {
        event.stopPropagation()
      }

      let self = this
      let confirmDelete = self.pax['covid19_portal'][1].CONFIRM_DELETE
        ? self.pax['covid19_portal'][1].CONFIRM_DELETE
        : 'Confirm delete'

      let buttonOk = self.pax['covid19_portal'][1].CONFIRM_TEXT ? self.pax['covid19_portal'][1].CONFIRM_TEXT : 'Ok'

      let confirm = this.$swal({ title: confirmDelete, confirmButtonText: buttonOk })
      confirm.then((result) => {
        if (result.value) {
          self.deleteFiles(index)
        }
      })
    },
    deleteFiles: function (index) {
      var id = this.documents[index].passenger_doc_id
      if (!id) {
        return false
      }
      // Delete data
      this.$store
        .dispatch('MyDocument/deletePassengerDocuments', {
          data: {
            secrect: this.secret,
            id: id
          }
        })
        .then((response) => {
          if (response.success) {
            this.documents[index].pass_doc_path = null
            if (this.documents[index].checked) {
              this.handleChecked(index, { target: { checked: false } })
            }
          }
        })
    },
    handleOpenFile: function (url) {
      if (!url) {
        return true
      }

      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.my-documents-item {
  cursor: pointer;
}

.text-decoration-underline {
  text-decoration: underline;
}

.my-documents {
  .icon-file,
  .icon-chevron-right {
    color: rgb(170, 176, 193);
  }

  .air-doc-title {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    cursor: pointer;
  }

  .my-documents-item-icon {
    cursor: pointer;
    color: #519dff;
    font-size: 25px;

    &--add {
      color: #519dff;
    }
  }

  .ws-checkbox-container {
    padding-left: 1.25rem;
  }
}

.padding-right-5px {
  padding-right: 5px;
}

.section-mandatory-document {
  font-size: 18px;
}
</style>
